// Style
import "./title-path.scss";
import { Fragment, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { ICampaignWizardForm } from "../../../../../../../../../../shared/types/form.type";
import { getFormTitlePathSegments } from "../../utils/form-title-path";

export const TitlePath = () => {
	const { control } = useFormContext<ICampaignWizardForm>();
	const formType = useWatch({ control, name: "type" });

	const segments = useMemo(
		() => getFormTitlePathSegments(formType),
		[formType],
	);

	const arrowIcon = "/img/icons/arrow.png";

	return (
		<div className='title-path'>
			<div className='title-path__wrapper'>
				{segments.map((segment, index) => (
					<Fragment key={`${segment}-${index}`}>
						{index > 0 ? (
							<img src={arrowIcon} alt='' aria-hidden />
						) : null}
						<span>{segment}</span>
					</Fragment>
				))}
			</div>
		</div>
	);
};
